import {register} from '@shopify/theme-sections';

import initPagination from '../components/pagination';

const sectionType = 'main-blog';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      initPagination(this.id);
    },
  });
